<div class="settings-rooms">
  <andor-fieldset [headline]="'Rooms' | translate" size="fill">
    @if (error()) {
      <div class="notification error">
        <div class="text">{{ error() }}</div>
        <andor-icon-btn (clickHandler)="error.set(null)" [aria-label]="'Dismiss' | translate">
          <fa-icon [icon]="faClose"></fa-icon>
        </andor-icon-btn>
      </div>
    }
    <ul class="room-list">
      @for (room of rooms(); track room.roomId) {
        <li class="room-row">
          <div class="info">
            <div class="name-row">
              <span class="name" [andorTextTicker]="room.name">
                <span class="ticker-text">{{ room.name }}</span>
              </span>
              @if (room.isPrivate) {
                <fa-duotone-icon
                  class="badge"
                  [icon]="faLock"
                  [title]="'Private room' | translate"></fa-duotone-icon>
              }
              @if (room.hasPassword) {
                <fa-duotone-icon
                  class="badge"
                  [icon]="faKey"
                  [title]="'Password protected' | translate"></fa-duotone-icon>
              }
            </div>
            <span class="meta">
              {{ room.memberCount }}
              <fa-duotone-icon
                class="meta-icon"
                [icon]="faPeopleGroup"
                [title]="'Online' | translate"></fa-duotone-icon>
              @if (room.schedule) {
                <fa-duotone-icon
                  class="meta-icon"
                  [icon]="faClock"
                  [title]="'Scheduled' | translate"></fa-duotone-icon>
              }
            </span>
          </div>
          <andor-icon-btn
            class="invite"
            [tooltip]="'Copy invite link' | translate"
            [aria-label]="'Copy invite link' | translate"
            (clickHandler)="copyInviteLink(room)">
            <fa-icon [icon]="faLink"></fa-icon>
          </andor-icon-btn>
          <andor-icon-btn
            class="edit"
            [disabled]="removing() === room.roomId"
            [tooltip]="'Edit room' | translate"
            [aria-label]="'Edit room' | translate"
            (clickHandler)="editRoom(room)">
            <fa-icon [icon]="faPen"></fa-icon>
          </andor-icon-btn>
          <andor-icon-btn
            class="remove"
            [disabled]="removing() === room.roomId"
            [tooltip]="'Delete room' | translate"
            [aria-label]="'Delete room' | translate"
            (clickHandler)="deleteRoom(room)">
            <fa-icon [icon]="faTrash"></fa-icon>
          </andor-icon-btn>
        </li>
      } @empty {
        <li class="state empty">
          <fa-duotone-icon [icon]="faDoorOpen"></fa-duotone-icon>
          <span>{{ 'No rooms available.' | translate }}</span>
        </li>
      }
    </ul>
  </andor-fieldset>
</div>
